import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditAcademicTerm from '../../components/academicTerms/FormAddEditAcademicTerm';
import { useParams } from 'react-router-dom';
import { useGetAcademicTerm } from '../../hooks/academicTerms/useGetAcademicTerm';
import LoadingPage from '../../components/global/LoadingPage';

const EditAcademicTerm = () => {
    const { id } = useParams();
    const { academicTerm, isLoading } = useGetAcademicTerm(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAcademicTerm isEdit currentData={academicTerm?.data} />
        </WrapperSection>
    );
};

export default EditAcademicTerm;
